export default __webpack_public_path__ + "static/multi-project-feature-flags-dark-85d30724564abcb905d01e0512f54df0.png";